export { NotificationsTab } from './notifications-tab';
